<template>
  <div>
    <div v-if="!fetched">
      <vue-default-svg-loader></vue-default-svg-loader>
    </div>
    <div v-else-if="fetched && clientPhoneNumbers.length > 0">
      <display-data
        v-for="(number, index) in clientPhoneNumbers"
        :key="index"
        :display-data="number"
        :display-title="number.number_type"
        :display-value="number.number"
        :edit-form.sync="clientContactNumberForm"
        :data.sync="selectedClientContactNumberData"
        :delete.sync="deleteDialogue"
        editable
        deletable
        class="hover-grey"
      ></display-data>
    </div>
    <div v-else>
      <vue-no-data :text="`Client contact numbers not found.`"></vue-no-data>
    </div>
    <div>
      <!-- Client Contact Number Form -->
      <v-bottom-sheet v-model="clientContactNumberForm">
        <v-card tile>
          <vue-card-title
            :title="cardTitle"
            :subtitle="
              'Fill up the following form to action on client contact number.'
            "
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            @close="clientContactNumberForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
          <v-card-text class="form-scroll">
            <client-contact-number-form
              v-if="selectedClientContactNumberData && clientContactNumberForm"
              :action-data="selectedClientContactNumberData"
              @clientContactNumberFormResponse="formSuccess"
              :client-slug="clientSlug"
            >
            </client-contact-number-form>
          </v-card-text>
        </v-card>
      </v-bottom-sheet>
      <!-- / Client Contact Number Form -->

      <!-- Confirm Client Contact Number Delete -->
      <vue-delete-dialogue
        :open-dialogue.sync="deleteDialogue"
        card-header-info="Confirm Client Contact Number Deletion"
        :card-text-info="
          `Are you sure you want to delete this number ` +
            selectedClientContactNumberData.number +
            ` ?`
        "
        @confirm-delete="deleteContactNumber()"
      ></vue-delete-dialogue>
      <!-- / Confirm Client Contact Number Delete -->
    </div>
  </div>
</template>

<script>
import DisplayData from "@/components/crm/layout_utils/DisplayData";
import ClientContactNumberForm from "@/components/crm/client/forms/ClientContactNumberForm";

export default {
  components: { ClientContactNumberForm, DisplayData },
  props: {
    clientSlug: {
      type: String,
      required: false,
      default: ""
    },
    clientContactNumberForm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fetched: false,
      confirmClientContactNumberDelete: false,
      deleteDialogue: false,
      clientPhoneNumbers: [],
      // form
      selectedClientContactNumberData: {},
      cardTitle: ""
    };
  },
  watch: {
    clientContactNumberForm(newVal) {
      this.$emit("update:contactNumberForm", newVal);
      if (
        Object.keys(this.selectedClientContactNumberData).length > 0 &&
        newVal
      ) {
        this.cardTitle = "Update Client Contact Number";
      } else {
        this.selectedClientContactNumberData = {};
        this.cardTitle = "Create Client Contact Number";
      }
    },
    deleteDialogue(newVal) {
      if (!newVal) this.selectedClientContactNumberData = {};
    },
    clientSlug() {
      this.fetchClientPhoneNumbers();
    }
  },
  // created() {
  //   this.fetchClientPhoneNumbers();
  // },
  methods: {
    fetchClientPhoneNumbers() {
      const clientPhoneNumbersAPI = "/api/v1/crm/client-phone-number/";
      this.fetched = false;
      const params = {
        client__slug: this.clientSlug
      };
      this.$axios.$get(clientPhoneNumbersAPI, { params }).then(response => {
        this.clientPhoneNumbers = response;
        this.fetched = true;
      });
    },
    formSuccess() {
      this.clientContactNumberForm = false;
      this.fetchClientPhoneNumbers();
    },
    deleteContactNumber() {
      const clientPhoneNumbersDeleteAPI = `/api/v1/crm/client-phone-number/${this.selectedClientContactNumberData.id}/`;
      this.$axios.$delete(clientPhoneNumbersDeleteAPI).then(() => {
        const index = this.clientPhoneNumbers.indexOf(
          this.selectedClientContactNumberData
        );
        this.clientPhoneNumbers.splice(index, 1);
        this.deleteDialogue = false;
      });
    }
  }
};
</script>
